<template>
    <div class="page_container">
        <Banner />
        <Content class="content" />
    </div>
</template>

<script>
import Banner from './components/Banner';
import Content from './components/Content';

export default {
    components: {
        Banner,
        Content,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.page_container {
    min-width: 1110px;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    .content {
        flex: 1;
    }
}
</style>
